import { PayflowTopBarService } from './services/PayflowTopBarService';
import type { Init, ReturnUrlAdapter } from './types';
import { managerHelpers } from '../../helpers';
import type { WidgetLifecycle } from '../WidgetLifecycle';
import { WithApi } from '../WithApi';

type TApi = ReturnType<PayflowTopBarService['api']>;

export class PayflowTopBarManager extends WithApi<TApi> {
  constructor(private urlAdapter: ReturnUrlAdapter) {
    super();
  }

  public payflowTopBarInit = ({ pageStore, queries, flags }: Init) => {
    const [planGroupQuery, partnerSummaryQuery] = queries;

    const pending = planGroupQuery.isPending || partnerSummaryQuery.isPending;
    const error = planGroupQuery.error || partnerSummaryQuery.error;

    if (pending) {
      return {
        status: 'pending',
        data: null,
        handlers: null,
        lifecycle: {} as WidgetLifecycle,
      } as const;
    }

    if (error) {
      return {
        status: 'error',
        data: error,
        handlers: {
          retry: () => {
            managerHelpers.retryQueries(queries);
          },
        },
        lifecycle: {} as WidgetLifecycle,
      } as const;
    }

    const payflowTopBarService = new PayflowTopBarService(
      pageStore,
      this.urlAdapter,
      planGroupQuery.data,
      partnerSummaryQuery.data,
      flags
    );

    this.initApi({
      ...payflowTopBarService.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...payflowTopBarService.data(),
      },
      handlers: {
        ...payflowTopBarService.handlers(),
      },
      lifecycle: {
        onMount() {
          payflowTopBarService.onMount();
        },
      } as WidgetLifecycle,
    } as const;
  };
}
